import { Button } from "@progress/kendo-react-buttons";
import { Window } from "@progress/kendo-react-dialogs";
import {
    plusIcon,
    pencilIcon,
    userIcon
} from "@progress/kendo-svg-icons";
import React, { useEffect } from "react";
import { useGetTenantQuery, useGetUserProfileQuery } from "../../redux/api/BaseApi";
import { PartialSpinny } from "../Nav/Spinny";
import { UserApi } from "../../redux/api/UserApi";
import { SvgIcon } from "@progress/kendo-react-common";
import { useReduxDispatch } from "../../redux/hooks";

///A modal that displays the user's details when clicking the Add / Edit icon on the log a ticket dialog.
const UserDetailsModal = (props: UserModalProps) => {
    const dispatch = useReduxDispatch();
    const { data: tenant } = useGetTenantQuery()
    const [newUserId, setNewUserId] = React.useState<number>();
    const { data: newUser, refetch } = UserApi.useGetUserByIdQuery(newUserId, { skip: !newUserId });
    const { data: classification } = UserApi.useGetUserClassificationQuery();
    const [ifameProps, setIfameProps] = React.useState<IframeProps>({ contactId: 0, visible: false });
    const { data: userProfile } = useGetUserProfileQuery();

    useEffect(() => {
        //console.log('useEffect', newUser, newUserId);
        if (newUser && props.userCreated && newUserId == newUser.ID && classification) {
            console.log('User Updated', newUser?.F_Name, newUser?.L_Name, newUser?.Company_Name, newUser?.[classification?.Field_Name]);
            //The contact display name should use the secondary user classification field if it is set otherwith the company_name
            var displayName = `${newUser?.FullName} - ${((classification?.Field_Name && newUser?.[classification?.Field_Name]) || newUser?.Company_Name)}`;
            refetch().then(() => {
                console.log('User Updated2', newUser?.F_Name, newUser?.L_Name, newUser?.Company_Name, newUser?.[classification?.Field_Name]);

                props.userCreated({ ...newUser, Contact_Name: displayName, Contact_Id: newUser.ID });
                setNewUserId(null);
            });
        }
    }, [newUser, newUserId, classification]);

    useEffect(() => {
        //Add event listener for Events that get posted when a user is created or edited.
        const messageListener = (e) => {
            console.log('Message Recieved', e.data);
            try {
                if (e.data?.indexOf && e.data?.indexOf('{') === 0) {
                    console.log('JSON Message Recieved', e.data);
                    var messageObj = JSON.parse(e.data);
                    if ('message' in messageObj && messageObj.message === 'user_created' && 'contactId' in messageObj) {
                        if (messageObj.contactId != '0') {
                            //clear API cache because the user details may have been edited in the old UI
                            //console.log('UserApi.util.invalidateTags');
                            //dispatch(UserApi.util.invalidateTags(["GetUsersById", "GetUsersByIds", "GetUsers"]));

                            //console.log('setNewUserId', messageObj.contactId);
                            setNewUserId(messageObj.contactId);
                        }
                        //props.userCreated && props.userCreated({ Contact_Id: messageObj.contactId });

                        setIfameProps({ visible: false, contactId: 0 });
                    }
                }
            } catch (err) {
                console.error('ouch in window.addEventListener', err);
            }
        };

        var ev = window.addEventListener("message", messageListener, false)
        //console.log('addEventListener added', messageListener);
        return () => { window.removeEventListener("message", messageListener) }
    }, []);

    return (
        tenant &&
        <>
            <Button type="button" formNoValidate className="buttons-container-button" svgIcon={plusIcon} onClick={() => setIfameProps({ iFrameLoading: true, visible: true, contactId: 0 })} title={`Add ${userProfile?.Phrases.EndUser}`}>
            </Button>
            {props?.contactId > 0 && <Button type="button" formNoValidate className="buttons-container-button" svgIcon={pencilIcon} onClick={() => setIfameProps({ iFrameLoading: true, visible: true, contactId: props?.contactId })} title={`Edit ${userProfile?.Phrases.EndUser}`}>
            </Button>}
            {ifameProps?.visible &&
                <Window
                    minimizeButton={() => null}
                    initialWidth={1000}
                    initialHeight={800}
                    className="user-details cool-window"
                    onClose={() => setIfameProps({ visible: false, contactId: 0 })}
                    title={
                        <>
                            <SvgIcon icon={userIcon} className="pt-1"></SvgIcon><span className="pl-3">{ifameProps?.contactId ? `Edit ${userProfile?.Phrases.EndUser}` : `Add ${userProfile?.Phrases.EndUser}`}</span>
                        </>}
                    modal={true}
                >
                    {/* A fullscreen IfraME WINDOW to the user details aspx page */}
                    <div className="inline-block w-full h-full">
                        {ifameProps.iFrameLoading && <PartialSpinny z={98} />}
                        <iframe src={`${tenant?.Tenant_Url}/contacts/contactinfo.aspx?LogCallPopup=1&company_id=${props?.companyId}&contact_Id=${ifameProps?.contactId}`} className="w-full h-full" onLoad={() => setIfameProps((props) => { return { ...props, iFrameLoading: false } })}>
                        </iframe>
                    </div>
                </Window>}
        </>
    );
}

interface UserModalProps {
    contactId?: number,
    companyId?: number,
    userCreated?: (e: any) => void
}

interface IframeProps {
    contactId: number,
    visible: boolean,
    iFrameLoading?: boolean
}


export default UserDetailsModal;
